/**
 * Android wait-list sign-up (POST /api/v1/android/subscribeWaitList). The
 * endpoint is open: no Firebase ID token. Relative path through the dev
 * proxy. Failures are RETURNED, never thrown, with a message to show.
 */
import axios from 'axios';
import type { AndroidWaitListSubscribeRequest } from '@stash/shared-types';

const URL = '/api/v1/android/subscribeWaitList';

export type AndroidWaitListResult = { ok: true } | { ok: false; message: string };

export async function subscribeAndroidWaitList(request: AndroidWaitListSubscribeRequest): Promise<AndroidWaitListResult> {
  try {
    await axios.post(URL, request);
    return { ok: true };
  } catch (error) {
    const response = (error as { response?: { data?: { message?: unknown } } }).response;
    if (!response) return { ok: false, message: 'Could not reach STASH. Check your connection and try again.' };
    const message = response.data?.message;
    return { ok: false, message: typeof message === 'string' && message ? message : 'We could not save that. Please try again.' };
  }
}
